import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Localization, UserSession_$reflection, GenericResponse_$reflection, Localization_$reflection } from "./Shared/ApiDataTypes.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { unwrap, map, defaultArg, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { testRedirect, extraCoders, corsProps } from "./Promises.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton, tail, head, isEmpty, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { union_type, list_type, string_type, option_type, int32_type, obj_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { API_Localization_Root } from "./Shared/Urls.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { nbNO, enUS } from "@mui/material/locale";
import { StyleImports_createTheme_argsArray } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Styles.fs.js";
import { fromFlatEntries } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Flatten.fs.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { toString as toString_1, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { Route_$007CQuery$007C_$007C, Route_$007CInt$007C_$007C } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { CssBaseline, Drawer, ThemeProvider, CircularProgress, Backdrop, Typography } from "@mui/material";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { RouterModule_router, RouterModule_urlSegments, RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { useResponsive } from "./Utils.js";
import { getLocale, getProvider, tryReadLocaleFromCookie } from "./Locale.js";
import { Localization_Language } from "./Shared/Shared.js";
import { ctx, GlobalCtx, GlobalCtx_New_11EF06A4 } from "./Context.js";
import { append, toArray, singleton as singleton_1, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { LogoNavbar } from "./Navbar.js";
import { CompanyHierarchyProvider } from "./CompanyHierarchyContext.js";
import { Components_CompanyHierarchySidebar_3A59D1F3 } from "./Components/CompanyHierarchySidebar.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Service } from "./Machine/MachineServiceView.js";
import { Ticket } from "./Ticket/Ticket.js";
import { View } from "./TicketCenter.js";
import { ContactInfo } from "./CustomerContact.js";
import { View as View_1 } from "./Admin.js";
import { View as View_2 } from "./HelpdeskView.js";
import { View as View_3 } from "./MyAccount.js";
import { View as View_4 } from "./Home.js";
import { Activate } from "./Activate.js";
import { Recover } from "./PasswordRecovery.js";
import { Login } from "./Login.js";
import { createRoot } from "react-dom/client";

function tryUpdateLocale(locale) {
    let properties_2;
    const body = Auto_generateBoxedEncoder_437914C6(Localization_$reflection(), undefined, undefined, undefined)(locale);
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = some(body);
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(API_Localization_Root, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
    }
    catch (exn) {
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
}

function PtgTheme(lang) {
    const custom = (key, value) => [key, value];
    const theme = ofArray([["palette.primary.main", "#253746"], ["palette.text.primary", "rgba(37, 55, 70, 1)"], ["typography.fontFamily", "Roboto"], ["typography.h1.color", "var(--navy)"], ["typography.h1.fontSize", "60px"], ["typography.h1.fontWeight", 500], ["typography.h2.color", "var(--navy)"], ["typography.h2.fontSize", "42px"], ["typography.h2.fontWeight", 500], ["typography.h3.color", "var(--navy)"], ["typography.h3.fontSize", "32px"], ["typography.h3.fontWeight", 500], ["typography.h4.color", "var(--navy)"], ["typography.h4.fontSize", "20px"], ["typography.h4.fontWeight", 500], ["typography.h5.color", "var(--navy)"], ["typography.h5.fontSize", "16px"], ["typography.h5.fontWeight", 500], ["typography.h5.lineHeight", 1.66], ["typography.h6.lineHeight", 1.28], ["typography.h6.fontSize", "16px"], ["typography.subtitle2.fontSize", "14px"], ["typography.subtitle2.fontWeight", 400], custom("typography.body3.fontSize", "12px"), custom("typography.body3.lineHeight", "15.6px"), custom("typography.body3.fontWeight", "600"), custom("typography.body3-bold.fontSize", "12px"), custom("typography.body3-bold.lineHeight", "14.4px"), custom("typography.body3-bold.fontWeight", "500"), ["components.MuiFormControl.defaultProps", {
        variant: "standard",
    }], ["components.MuiSelect.defaultProps", {
        variant: "outlined",
    }], ["components.MuiLink.defaultProps", {
        underline: "none",
    }], ["components.MuiButton.defaultProps", {
        variant: "contained",
    }], ["components.MuiTextField.defaultProps", {
        variant: "outlined",
    }]]);
    const merge = [(lang.tag === 1) ? enUS : nbNO];
    return StyleImports_createTheme_argsArray(fromFlatEntries(theme), ...merge);
}

class Pages extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Account", "Admin", "Home", "SignOut", "TicketCenter", "Ticket", "Contact", "Service", "Helpdesk", "NotFound"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "/admin" : ((this$.tag === 2) ? "/home" : ((this$.tag === 3) ? "/sign-out" : ((this$.tag === 4) ? "/ticket-center" : ((this$.tag === 5) ? "/ticket" : ((this$.tag === 6) ? "/contact" : ((this$.tag === 7) ? "/account" : ((this$.tag === 8) ? "/account" : ((this$.tag === 9) ? join("/", this$.fields[0]) : "/account"))))))));
    }
}

function Pages_$reflection() {
    return union_type("Kundeweb.App.Pages", [], Pages, () => [[], [], [], [], [], [["Item", int32_type]], [["Item", option_type(int32_type)]], [["Item1", int32_type], ["Item2", int32_type], ["Item3", int32_type], ["Item4", int32_type]], [], [["path", list_type(string_type)]]]);
}

function parseUrl(pathList) {
    let matchResult, customerId;
    if (!isEmpty(pathList)) {
        switch (head(pathList)) {
            case "": {
                matchResult = 1;
                break;
            }
            case "group": {
                matchResult = 2;
                break;
            }
            case "contact": {
                if (!isEmpty(tail(pathList))) {
                    const activePatternResult = Route_$007CInt$007C_$007C(head(tail(pathList)));
                    if (activePatternResult != null) {
                        if (isEmpty(tail(tail(pathList)))) {
                            matchResult = 4;
                            customerId = activePatternResult;
                        }
                        else {
                            matchResult = 5;
                        }
                    }
                    else {
                        matchResult = 5;
                    }
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            default:
                matchResult = 5;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Pages(2, []);
        case 1:
            return new Pages(2, []);
        case 2:
            return new Pages(2, []);
        case 3:
            return new Pages(6, [undefined]);
        case 4:
            return new Pages(6, [customerId]);
        default: {
            let matchResult_1, customerId_1, groupId, machineId, serviceId;
            if (!isEmpty(pathList)) {
                if (head(pathList) === "group") {
                    if (!isEmpty(tail(pathList))) {
                        const activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(pathList)));
                        if (activePatternResult_1 != null) {
                            if (!isEmpty(tail(tail(pathList)))) {
                                if (head(tail(tail(pathList))) === "customer") {
                                    if (!isEmpty(tail(tail(tail(pathList))))) {
                                        const activePatternResult_2 = Route_$007CInt$007C_$007C(head(tail(tail(tail(pathList)))));
                                        if (activePatternResult_2 != null) {
                                            if (!isEmpty(tail(tail(tail(tail(pathList)))))) {
                                                if (head(tail(tail(tail(tail(pathList))))) === "machine") {
                                                    if (!isEmpty(tail(tail(tail(tail(tail(pathList))))))) {
                                                        const activePatternResult_3 = Route_$007CInt$007C_$007C(head(tail(tail(tail(tail(tail(pathList)))))));
                                                        if (activePatternResult_3 != null) {
                                                            if (!isEmpty(tail(tail(tail(tail(tail(tail(pathList)))))))) {
                                                                if (head(tail(tail(tail(tail(tail(tail(pathList))))))) === "service") {
                                                                    if (!isEmpty(tail(tail(tail(tail(tail(tail(tail(pathList))))))))) {
                                                                        const activePatternResult_4 = Route_$007CInt$007C_$007C(head(tail(tail(tail(tail(tail(tail(tail(pathList)))))))));
                                                                        if (activePatternResult_4 != null) {
                                                                            if (isEmpty(tail(tail(tail(tail(tail(tail(tail(tail(pathList)))))))))) {
                                                                                matchResult_1 = 0;
                                                                                customerId_1 = activePatternResult_2;
                                                                                groupId = activePatternResult_1;
                                                                                machineId = activePatternResult_3;
                                                                                serviceId = activePatternResult_4;
                                                                            }
                                                                            else {
                                                                                matchResult_1 = 1;
                                                                            }
                                                                        }
                                                                        else {
                                                                            matchResult_1 = 1;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult_1 = 1;
                                                                    }
                                                                }
                                                                else {
                                                                    matchResult_1 = 1;
                                                                }
                                                            }
                                                            else {
                                                                matchResult_1 = 1;
                                                            }
                                                        }
                                                        else {
                                                            matchResult_1 = 1;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_1 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_1 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_1 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_1 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new Pages(7, [groupId, customerId_1, machineId, serviceId]);
                default: {
                    let matchResult_2, _id, id;
                    if (!isEmpty(pathList)) {
                        switch (head(pathList)) {
                            case "customer": {
                                matchResult_2 = 0;
                                break;
                            }
                            case "machine": {
                                if (!isEmpty(tail(pathList))) {
                                    const activePatternResult_5 = Route_$007CInt$007C_$007C(head(tail(pathList)));
                                    if (activePatternResult_5 != null) {
                                        matchResult_2 = 1;
                                        _id = activePatternResult_5;
                                    }
                                    else {
                                        matchResult_2 = 3;
                                    }
                                }
                                else {
                                    matchResult_2 = 3;
                                }
                                break;
                            }
                            case "tickets": {
                                if (!isEmpty(tail(pathList))) {
                                    const activePatternResult_6 = Route_$007CInt$007C_$007C(head(tail(pathList)));
                                    if (activePatternResult_6 != null) {
                                        if (isEmpty(tail(tail(pathList)))) {
                                            matchResult_2 = 2;
                                            id = activePatternResult_6;
                                        }
                                        else {
                                            matchResult_2 = 3;
                                        }
                                    }
                                    else {
                                        matchResult_2 = 3;
                                    }
                                }
                                else {
                                    matchResult_2 = 3;
                                }
                                break;
                            }
                            default:
                                matchResult_2 = 3;
                        }
                    }
                    else {
                        matchResult_2 = 3;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return new Pages(2, []);
                        case 1:
                            return new Pages(2, []);
                        case 2:
                            return new Pages(5, [id]);
                        default: {
                            let matchResult_3, otherwise;
                            if (!isEmpty(pathList)) {
                                switch (head(pathList)) {
                                    case "tickets": {
                                        if (isEmpty(tail(pathList))) {
                                            matchResult_3 = 0;
                                        }
                                        else {
                                            matchResult_3 = 5;
                                            otherwise = pathList;
                                        }
                                        break;
                                    }
                                    case "admin": {
                                        matchResult_3 = 1;
                                        break;
                                    }
                                    case "helpdesk": {
                                        matchResult_3 = 2;
                                        break;
                                    }
                                    case "account": {
                                        if (isEmpty(tail(pathList))) {
                                            matchResult_3 = 3;
                                        }
                                        else {
                                            matchResult_3 = 5;
                                            otherwise = pathList;
                                        }
                                        break;
                                    }
                                    case "signout": {
                                        if (isEmpty(tail(pathList))) {
                                            matchResult_3 = 4;
                                        }
                                        else {
                                            matchResult_3 = 5;
                                            otherwise = pathList;
                                        }
                                        break;
                                    }
                                    case "logout": {
                                        if (isEmpty(tail(pathList))) {
                                            matchResult_3 = 4;
                                        }
                                        else {
                                            matchResult_3 = 5;
                                            otherwise = pathList;
                                        }
                                        break;
                                    }
                                    default: {
                                        matchResult_3 = 5;
                                        otherwise = pathList;
                                    }
                                }
                            }
                            else {
                                matchResult_3 = 5;
                                otherwise = pathList;
                            }
                            switch (matchResult_3) {
                                case 0:
                                    return new Pages(4, []);
                                case 1:
                                    return new Pages(1, []);
                                case 2:
                                    return new Pages(8, []);
                                case 3:
                                    return new Pages(0, []);
                                case 4:
                                    return new Pages(3, []);
                                default:
                                    return new Pages(9, [otherwise]);
                            }
                        }
                    }
                }
            }
        }
    }
}

function notFoundView(key, notFoundText, notFoundDesc) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: 20,
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", notFoundText]]), MuiHelpers_createElement(Typography, [["variant", "body1"], ["children", notFoundDesc]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function verifyingUser() {
    let elems;
    return MuiHelpers_createElement(Backdrop, [["open", true], ["style", {
        backgroundColor: "rgba(37, 55, 70, 0.75)",
        color: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
    }], (elems = [createElement("span", {
        style: {
            margin: 10,
        },
    }), MuiHelpers_createElement(CircularProgress, [["color", "inherit"], ["size", 2 + "em"]])], ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

function LogOutView(logOutViewInputProps) {
    let elems;
    const setSession = logOutViewInputProps.setSession;
    const key = logOutViewInputProps.$key;
    useEffectOnce(() => {
        const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
            let pr_1, decoder, data_1, caseStrategy_2, extra_2;
            return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(obj_type, undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/auth/logout", properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_3) => (((RouterModule_nav(singleton("/login"), 1, 1), Promise.resolve())).then(() => PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
                setSession(undefined);
                return Promise.resolve();
            }))));
        }));
        pr_2.then();
    });
    return MuiHelpers_createElement(Backdrop, [["open", true], ["style", {
        backgroundColor: "rgba(37, 55, 70, 0.75)",
        color: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
    }], (elems = [createElement("span", {
        style: {
            margin: 10,
        },
    }), MuiHelpers_createElement(CircularProgress, [["color", "inherit"], ["size", 2 + "em"]])], ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

export function Render() {
    let elements_2;
    let patternInput;
    const initial = RouterModule_urlSegments(window.location.hash, 1);
    patternInput = reactApi.useState(initial);
    const currentUrl = patternInput[0];
    const currentPage = parseUrl(currentUrl);
    const responsive = useResponsive(undefined);
    const patternInput_1 = reactApi.useState(true);
    const loadingSession = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setSession = patternInput_2[1];
    const session = patternInput_2[0];
    let initLang;
    const matchValue = tryReadLocaleFromCookie();
    initLang = ((matchValue != null) ? matchValue : (new Localization_Language(0, [])));
    const patternInput_3 = reactApi.useState(initLang);
    const lang = patternInput_3[0];
    let patternInput_4;
    const initial_4 = getProvider(lang);
    patternInput_4 = reactApi.useState(initial_4);
    const locale = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const sidebarOpen = patternInput_5[0];
    const setSidebarOpen = patternInput_5[1];
    const patternInput_6 = reactApi.useState(false);
    reactApi.useEffect(() => {
        let properties_2;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(UserSession_$reflection(), undefined, undefined);
        let pr_1;
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = undefined;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/auth/contest-session", properties_3).then((_arg_1) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(UserSession_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                    let matchValue_1;
                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            if (res.tag === 0) {
                setSession(res.fields[0]);
            }
            else {
                console.error(some("Could not load user session!"));
            }
            patternInput_1[1](false);
        });
    }, []);
    const dependencies_2 = [lang];
    reactApi.useEffect(() => {
        if (!loadingSession) {
            if (session != null) {
                const langStr = toString_1(lang);
                console.debug("Logged in, so updating locale in database: ", langStr);
                const pr_2 = tryUpdateLocale(new Localization(langStr));
                pr_2.then((res_1) => {
                    if (res_1.tag === 0) {
                        const matchValue_2 = res_1.fields[0].Result;
                        switch (matchValue_2) {
                            case "success": {
                                console.info(some("Updated locale to "), langStr);
                                break;
                            }
                            case "failure": {
                                console.error(some("Could not update locale to "), langStr);
                                break;
                            }
                            default:
                                console.error(some("Unknown error"));
                        }
                    }
                    else {
                        console.error(some("Could not update locale to "), langStr);
                    }
                });
            }
            else {
                console.debug("Not logged in. Will not try to update database");
            }
        }
    }, dependencies_2);
    if (loadingSession) {
        return verifyingUser();
    }
    else {
        const newCtx = new GlobalCtx(GlobalCtx_New_11EF06A4(session).Session, lang, locale, getLocale(lang), (newLang) => {
            const newLocale = getProvider(newLang);
            patternInput_3[1](newLang);
            patternInput_4[1](newLocale);
        }, sidebarOpen, setSidebarOpen, patternInput_6[0], patternInput_6[1]);
        const child = RouterModule_router(createObj(ofArray([["onUrlChanged", patternInput[1]], (elements_2 = toList(delay(() => {
            let elements_1, children;
            if (session != null) {
                return singleton_1(MuiHelpers_createElement(ThemeProvider, [["theme", PtgTheme(newCtx.Language)], (elements_1 = [(children = ofArray([createElement(LogoNavbar, null), createElement("main", {
                    style: {
                        width: ("calc(" + "100vw") + ")",
                        height: ("calc(" + "100vh - 120px") + ")",
                    },
                    children: createElement(CompanyHierarchyProvider, {
                        children: toArray(delay(() => {
                            let matchValue_5;
                            return append((matchValue_5 = responsive, (matchValue_5 === "mobileLandscape") ? singleton_1(MuiHelpers_createElement(Drawer, [["key", "company-hierarchy-sidebar-drawer"], ["anchor", "right"], ["open", sidebarOpen], ["onClose", (_arg_3) => {
                                setSidebarOpen(false);
                            }], ["children", createElement("div", {
                                style: {
                                    height: 100 + "%",
                                    padding: 20 + "px",
                                },
                                children: createElement(Components_CompanyHierarchySidebar_3A59D1F3, {
                                    key: "company-hierarchy-sidebar",
                                    $key: "company-hierarchy-sidebar",
                                    onClose: () => {
                                        setSidebarOpen(false);
                                    },
                                }),
                            })]])) : ((matchValue_5 === "tablet") ? singleton_1(MuiHelpers_createElement(Drawer, [["key", "company-hierarchy-sidebar-drawer"], ["anchor", "right"], ["open", sidebarOpen], ["onClose", (_arg_3) => {
                                setSidebarOpen(false);
                            }], ["children", createElement("div", {
                                style: {
                                    height: 100 + "%",
                                    padding: 20 + "px",
                                },
                                children: createElement(Components_CompanyHierarchySidebar_3A59D1F3, {
                                    key: "company-hierarchy-sidebar",
                                    $key: "company-hierarchy-sidebar",
                                    onClose: () => {
                                        setSidebarOpen(false);
                                    },
                                }),
                            })]])) : ((matchValue_5 === "desktop") ? singleton_1(defaultOf()) : ((matchValue_5 === "wideScreen") ? singleton_1(defaultOf()) : singleton_1(MuiHelpers_createElement(Drawer, [["key", "company-hierarchy-sidebar-drawer"], ["anchor", "right"], ["open", sidebarOpen], ["onClose", (_arg_3) => {
                                setSidebarOpen(false);
                            }], ["children", createElement("div", {
                                style: {
                                    height: 100 + "%",
                                    padding: 20 + "px",
                                },
                                children: createElement(Components_CompanyHierarchySidebar_3A59D1F3, {
                                    key: "company-hierarchy-sidebar",
                                    $key: "company-hierarchy-sidebar",
                                    onClose: () => {
                                        setSidebarOpen(false);
                                    },
                                }),
                            })]])))))), delay(() => {
                                let $key671487F, $key3EF3C4A5, $keyZ5F9CCD7E;
                                const matchValue_6 = currentPage;
                                switch (matchValue_6.tag) {
                                    case 7: {
                                        const mId = matchValue_6.fields[2] | 0;
                                        const id = matchValue_6.fields[3] | 0;
                                        const groupId = matchValue_6.fields[0] | 0;
                                        const customerId = matchValue_6.fields[1] | 0;
                                        return singleton_1(($key671487F = (`machine-service-view-${groupId}-${customerId}-${mId}-${id}`), createElement(Service, {
                                            key: $key671487F,
                                            $key: $key671487F,
                                            groupId: groupId,
                                            customerId: customerId,
                                            machineId: mId,
                                            serviceId: id,
                                        })));
                                    }
                                    case 5: {
                                        const ticketId = matchValue_6.fields[0] | 0;
                                        return singleton_1(($key3EF3C4A5 = (`ticket-${ticketId}-view`), createElement(Ticket, {
                                            key: $key3EF3C4A5,
                                            $key: $key3EF3C4A5,
                                            ticketId: ticketId,
                                        })));
                                    }
                                    case 4:
                                        return singleton_1(createElement(View, {
                                            key: "ticket-center-view",
                                            $key: "ticket-center-view",
                                        }));
                                    case 6: {
                                        const customerIdOpt = matchValue_6.fields[0];
                                        return singleton_1(($keyZ5F9CCD7E = (`contact-info-view-${customerIdOpt}`), createElement(ContactInfo, {
                                            key: $keyZ5F9CCD7E,
                                            $key: $keyZ5F9CCD7E,
                                            customerId: unwrap(customerIdOpt),
                                        })));
                                    }
                                    case 1:
                                        return singleton_1(createElement(View_1, {
                                            key: "admin-view",
                                            $key: "admin-view",
                                        }));
                                    case 8:
                                        return singleton_1(createElement(View_2, {
                                            key: "helpdesk-view",
                                            $key: "helpdesk-view",
                                        }));
                                    case 0:
                                        return singleton_1(createElement(View_3, {
                                            key: "my-account-view",
                                            $key: "my-account-view",
                                        }));
                                    case 3:
                                        return singleton_1(createElement(LogOutView, {
                                            key: "logout-view",
                                            $key: "logout-view",
                                            setSession: setSession,
                                        }));
                                    case 9: {
                                        console.warn(some("This path is not found"), matchValue_6.fields[0]);
                                        return singleton_1(notFoundView("not-found-view", locale.t("NotFound"), locale.t("NotFoundDesc")));
                                    }
                                    default:
                                        return singleton_1(createElement(View_4, {
                                            key: "home",
                                            $key: "home",
                                        }));
                                }
                            }));
                        })),
                    }),
                })]), MuiHelpers_createElement(CssBaseline, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_1))])]));
            }
            else {
                const matchValue_3 = currentUrl;
                let matchResult, token;
                if (!isEmpty(matchValue_3)) {
                    if (head(matchValue_3) === "activate") {
                        if (!isEmpty(tail(matchValue_3))) {
                            const activePatternResult = Route_$007CQuery$007C_$007C(head(tail(matchValue_3)));
                            if (activePatternResult != null) {
                                if (!isEmpty(activePatternResult)) {
                                    if (head(activePatternResult)[0] === "token") {
                                        if (isEmpty(tail(activePatternResult))) {
                                            if (isEmpty(tail(tail(matchValue_3)))) {
                                                matchResult = 0;
                                                token = head(activePatternResult)[1];
                                            }
                                            else {
                                                matchResult = 1;
                                            }
                                        }
                                        else {
                                            matchResult = 1;
                                        }
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return singleton_1(createElement(Activate, {
                            token: token,
                        }));
                    default: {
                        let matchResult_1, token_1;
                        if (!isEmpty(matchValue_3)) {
                            if (head(matchValue_3) === "password-recovery") {
                                if (!isEmpty(tail(matchValue_3))) {
                                    const activePatternResult_1 = Route_$007CQuery$007C_$007C(head(tail(matchValue_3)));
                                    if (activePatternResult_1 != null) {
                                        if (!isEmpty(activePatternResult_1)) {
                                            if (head(activePatternResult_1)[0] === "token") {
                                                if (isEmpty(tail(activePatternResult_1))) {
                                                    if (isEmpty(tail(tail(matchValue_3)))) {
                                                        matchResult_1 = 0;
                                                        token_1 = head(activePatternResult_1)[1];
                                                    }
                                                    else {
                                                        matchResult_1 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_1 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_1 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_1 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0:
                                return singleton_1(createElement(Recover, {
                                    token: token_1,
                                }));
                            default:
                                return singleton_1(createElement(Login, {
                                    onLoginSuccess: (s) => {
                                        const matchValue_4 = RouterModule_urlSegments(window.location.hash, 1);
                                        let matchResult_2;
                                        if (!isEmpty(matchValue_4)) {
                                            switch (head(matchValue_4)) {
                                                case "login": {
                                                    if (isEmpty(tail(matchValue_4))) {
                                                        matchResult_2 = 0;
                                                    }
                                                    else {
                                                        matchResult_2 = 1;
                                                    }
                                                    break;
                                                }
                                                case "logout": {
                                                    if (isEmpty(tail(matchValue_4))) {
                                                        matchResult_2 = 0;
                                                    }
                                                    else {
                                                        matchResult_2 = 1;
                                                    }
                                                    break;
                                                }
                                                default:
                                                    matchResult_2 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 0;
                                        }
                                        switch (matchResult_2) {
                                            case 0: {
                                                if (s.IsAdmin) {
                                                    RouterModule_nav(ofArray(["admin", "dashboard", "coh"]), 1, 1);
                                                }
                                                else {
                                                    RouterModule_nav(singleton(""), 1, 1);
                                                }
                                                break;
                                            }
                                        }
                                        setSession(s);
                                    },
                                }));
                        }
                    }
                }
            }
        })), ["application", react.createElement(react.Fragment, {}, ...elements_2)])])));
        return reactApi.createElement(ctx.Provider, {
            value: newCtx,
        }, child);
    }
}

export const root = createRoot(document.getElementById("kundeweb-app"));

root.render((() => {
    const children = singleton(createElement(Render, null));
    return reactApi.createElement(reactApi.StrictMode, undefined, ...children);
})());

